import { INITIAL_PAGE } from "../../module_auth/AuthService"

export function Pagination(props) {
    function getNextHref(page, lastPage) {
        let nextPage = parseInt(page) + 1
        if(nextPage > lastPage){
            nextPage = lastPage
        }
        let result = INITIAL_PAGE + 'job_list?page=' + nextPage + "&next=true";
        return result
    }

    function getPreviousHref(page) {
        let previousPage = parseInt(page) - 1
        if(previousPage < 1){
            previousPage = 1
        }
        let result = INITIAL_PAGE + 'job_list?page=' + previousPage + "&previous=true";
        return result
    }
    return (
        <div>
            <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center" style={{ marginTop: '15px' }}>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><a class="page-link" aria-label="Previous" href={getPreviousHref(props.page)}><span aria-hidden="true">«</span></a></li>

                        {PaginationBody(props.pageList, props.activePageIndex)}

                        <li class="page-item"><a class="page-link" aria-label="Next" href={getNextHref(props.page, props.lastPage)}><span aria-hidden="true">»</span></a></li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}


export function PaginationBody(pageList, activePage) {
    function getHref(page) {
        let result = INITIAL_PAGE + 'job_list?page=' + page
        return result
    }

    return (
        pageList.map((page, index) => (
            <li key={index} class={parseInt(activePage) === index ? "page-item active" : "page-item"}>
                <a class="page-link" href={getHref(page)}>{page}</a>
            </li>
        ))
    );
}